import React from 'react';

interface APRMONIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const APRMONIcon: React.FC<APRMONIconProps> = ({
  width = 32,
  height = 32,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="url(#paint0_linear_1146_79)"
      />
      <path
        d="M31.75 16C31.75 24.6985 24.6985 31.75 16 31.75C7.30152 31.75 0.25 24.6985 0.25 16C0.25 7.30152 7.30152 0.25 16 0.25C24.6985 0.25 31.75 7.30152 31.75 16Z"
        stroke="white"
        strokeOpacity="0.3"
        strokeWidth="0.5"
      />
      <path
        d="M24.6307 11.1183C24.8904 11.8337 25.0233 12.5979 25.0172 13.3831C25.0023 15.1217 24.3073 16.745 23.0603 17.9547C23.0311 17.9825 23.002 18.0103 22.9728 18.0388C22.6806 18.3202 22.3761 18.5962 22.0676 18.8593L22.0079 18.9243H21.9896C21.4831 19.3543 20.9481 19.7638 20.3995 20.1442C20.3887 20.1524 20.3778 20.1605 20.3663 20.1673C19.4251 20.8182 18.4236 21.3939 17.3902 21.8801L17.3766 21.8869C17.361 21.8937 17.3468 21.9011 17.3319 21.9079C16.6911 22.2069 16.03 22.4755 15.3668 22.706L15.3458 22.7121C15.3458 22.7121 15.3424 22.7128 15.3403 22.7135C15.0793 22.8043 14.8311 22.885 14.5897 22.9589C15.6767 23.9808 17.0871 24.5477 18.5965 24.5619C20.2157 24.5789 21.7367 23.9544 22.8765 22.8091C22.9111 22.7738 22.9457 22.7386 22.981 22.7033C23.0244 22.6585 23.0684 22.6138 23.1118 22.5684C23.1383 22.5412 23.1647 22.5141 23.1905 22.487C23.2536 22.4212 23.3173 22.3554 23.379 22.2897C25.755 19.7808 27.2597 17.358 27.2597 15.9998C27.2597 14.8986 26.271 13.0983 24.6307 11.1183Z"
        fill="white"
      />
      <path
        d="M18.5924 25.0366C16.8403 25.0196 15.2122 24.3144 14.0079 23.0512L13.9665 23.0078C13.6784 22.704 13.397 22.3887 13.1298 22.0707L13.0674 22.0083V21.9954C12.6382 21.4821 12.2307 20.9423 11.8536 20.391L11.8496 20.3849C11.8394 20.3693 11.8319 20.3571 11.8238 20.3449C11.1905 19.4166 10.6256 18.4239 10.1469 17.396C10.1347 17.3702 10.1211 17.3424 10.1076 17.3132C9.81059 16.6663 9.54817 16.0127 9.32711 15.3685C9.23693 15.1074 9.15285 14.8457 9.07487 14.584C8.04215 15.6811 7.46917 17.1037 7.45697 18.6219C7.4434 20.2283 8.0591 21.7391 9.19014 22.8769C9.22472 22.9121 9.25931 22.9461 9.29389 22.98C9.3461 23.0322 9.39763 23.0837 9.45052 23.1352C9.47629 23.161 9.50274 23.1861 9.5285 23.2112C9.60106 23.2817 9.67293 23.3515 9.74481 23.4207C12.2408 25.8062 14.6494 27.317 15.9994 27.317C17.1027 27.317 18.9138 26.3073 20.9006 24.6365C20.1927 24.8996 19.4353 25.0366 18.6555 25.0366H18.5924Z"
        fill="white"
      />
      <path
        d="M8.93794 14.0462C8.96709 14.0178 8.99625 13.9893 9.02609 13.9608C9.32173 13.6767 9.6289 13.3987 9.93878 13.1349L9.95438 13.1207C10.4724 12.6792 11.0169 12.2595 11.5723 11.8737C11.5818 11.8669 11.594 11.8587 11.6062 11.8506C12.5535 11.1942 13.5638 10.6118 14.606 10.1215C14.6209 10.114 14.6365 10.1066 14.6514 10.0991L14.6637 10.0937C15.297 9.79806 15.9432 9.53496 16.5874 9.31052L16.6416 9.29153C16.8925 9.20338 17.1502 9.11998 17.4106 9.04064C16.3229 8.01878 14.9125 7.4519 13.4024 7.43766C11.7818 7.42342 10.2622 8.04454 9.12305 9.1905C9.08644 9.22712 9.04982 9.26441 9.01388 9.30103C8.9732 9.34307 8.93183 9.38443 8.89183 9.42647C8.85996 9.45834 8.82944 9.49089 8.79825 9.52276C8.73994 9.58379 8.68094 9.64549 8.62331 9.70652C6.24528 12.2168 4.73926 14.6409 4.73926 15.9998C4.73926 17.101 5.72858 18.902 7.36886 20.8813C7.10847 20.1666 6.97557 19.4024 6.98235 18.6179C6.99659 16.8793 7.69094 15.2559 8.93794 14.0462Z"
        fill="white"
      />
      <path
        d="M17.9916 8.94843L18.033 8.99182C18.3232 9.29832 18.6039 9.61362 18.8691 9.92893L18.9314 9.99131V10.0042C19.3546 10.51 19.7587 11.0444 20.1344 11.5929L20.1452 11.6085C20.8043 12.5721 21.3868 13.596 21.8757 14.6524L21.8913 14.6857C22.1883 15.3332 22.4507 15.9876 22.6717 16.6311L22.6745 16.6392C22.7633 16.8962 22.846 17.1559 22.9247 17.4156C23.9567 16.3192 24.5297 14.8966 24.5426 13.379C24.5561 11.772 23.9404 10.2612 22.8094 9.12337C22.7741 9.08811 22.7389 9.05353 22.7043 9.01827C22.6514 8.96606 22.5992 8.91384 22.5463 8.86163C22.5226 8.83925 22.4995 8.8162 22.4758 8.79382C22.4019 8.72127 22.3273 8.64871 22.2527 8.57819C19.758 6.19338 17.3495 4.68262 15.9994 4.68262C14.8962 4.68262 13.085 5.69228 11.0983 7.36307C11.8252 7.0932 12.6049 6.95555 13.4071 6.963C15.1586 6.97928 16.7874 7.68448 17.9916 8.94843Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1146_79"
          x1="31.9681"
          y1="0.0318679"
          x2="0.149178"
          y2="31.8508"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B94DFF" />
          <stop offset="0.22" stopColor="#A14DFF" />
          <stop offset="0.49" stopColor="#8C4DFF" />
          <stop offset="0.75" stopColor="#804DFF" />
          <stop offset="1" stopColor="#7C4DFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default APRMONIcon;
